import "./main.css";
import $jn1ib$react, {useRef as $jn1ib$useRef, useEffect as $jn1ib$useEffect, useContext as $jn1ib$useContext, createContext as $jn1ib$createContext} from "react";
import {ToastQueue as $jn1ib$ToastQueue, useToastQueue as $jn1ib$useToastQueue} from "@react-stately/toast";
import {useSyncExternalStore as $jn1ib$useSyncExternalStore} from "use-sync-external-store/shim/index.js";
import $jn1ib$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import {Button as $jn1ib$Button, ClearButton as $jn1ib$ClearButton} from "@react-spectrum/button";
import {useDOMRef as $jn1ib$useDOMRef, useStyleProps as $jn1ib$useStyleProps, classNames as $jn1ib$classNames} from "@react-spectrum/utils";
import $jn1ib$spectrumiconsuiCrossMedium from "@spectrum-icons/ui/CrossMedium";
import $jn1ib$spectrumiconsuiInfoMedium from "@spectrum-icons/ui/InfoMedium";
import $jn1ib$spectrumiconsuiSuccessMedium from "@spectrum-icons/ui/SuccessMedium";
import {useLocalizedStringFormatter as $jn1ib$useLocalizedStringFormatter} from "@react-aria/i18n";
import {useToast as $jn1ib$useToast, useToastRegion as $jn1ib$useToastRegion} from "@react-aria/toast";
import {mergeProps as $jn1ib$mergeProps} from "@react-aria/utils";
import {Provider as $jn1ib$Provider} from "@react-spectrum/provider";
import $jn1ib$reactdom from "react-dom";
import {useFocusRing as $jn1ib$useFocusRing} from "@react-aria/focus";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




var $41e47081d30453d1$exports = {};
var $4ef3586572b5c0bd$exports = {};
$4ef3586572b5c0bd$exports = {
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "negative": `\u{62E}\u{637}\u{623}`,
    "positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`
};


var $9294a3bc0be7c803$exports = {};
$9294a3bc0be7c803$exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{413}\u{440}\u{435}\u{448}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};


var $2301cc9fa70c79b7$exports = {};
$2301cc9fa70c79b7$exports = {
    "info": `Informace`,
    "negative": `Chyba`,
    "positive": `\xdasp\u{11B}ch`
};


var $db68d63440e07cc2$exports = {};
$db68d63440e07cc2$exports = {
    "info": `Info`,
    "negative": `Fejl`,
    "positive": `Fuldf\xf8rt`
};


var $59f85255004b972f$exports = {};
$59f85255004b972f$exports = {
    "info": `Informationen`,
    "negative": `Fehler`,
    "positive": `Erfolg`
};


var $897a62d7e05e3ae7$exports = {};
$897a62d7e05e3ae7$exports = {
    "info": `\u{3A0}\u{3BB}\u{3B7}\u{3C1}\u{3BF}\u{3C6}\u{3BF}\u{3C1}\u{3AF}\u{3B5}\u{3C2}`,
    "negative": `\u{3A3}\u{3C6}\u{3AC}\u{3BB}\u{3BC}\u{3B1}`,
    "positive": `\u{395}\u{3C0}\u{3B9}\u{3C4}\u{3C5}\u{3C7}\u{3AF}\u{3B1}`
};


var $cd5f6f9dc2665e8f$exports = {};
$cd5f6f9dc2665e8f$exports = {
    "info": `Info`,
    "negative": `Error`,
    "positive": `Success`
};


var $91da3b58720e2afa$exports = {};
$91da3b58720e2afa$exports = {
    "info": `Informaci\xf3n`,
    "negative": `Error`,
    "positive": `\xc9xito`
};


var $d881203a181403bc$exports = {};
$d881203a181403bc$exports = {
    "info": `Teave`,
    "negative": `Viga`,
    "positive": `Valmis`
};


var $b39cb8320f170f5d$exports = {};
$b39cb8320f170f5d$exports = {
    "info": `Tiedot`,
    "negative": `Virhe`,
    "positive": `Onnistui`
};


var $3dcec82c37bb9c69$exports = {};
$3dcec82c37bb9c69$exports = {
    "info": `Infos`,
    "negative": `Erreur`,
    "positive": `Succ\xe8s`
};


var $70451b8bc8958a93$exports = {};
$70451b8bc8958a93$exports = {
    "info": `\u{5DE}\u{5D9}\u{5D3}\u{5E2}`,
    "negative": `\u{5E9}\u{5D2}\u{5D9}\u{5D0}\u{5D4}`,
    "positive": `\u{5D4}\u{5E6}\u{5DC}\u{5D7}\u{5D4}`
};


var $8192b2e4907779a9$exports = {};
$8192b2e4907779a9$exports = {
    "info": `Informacije`,
    "negative": `Pogre\u{161}ka`,
    "positive": `Uspje\u{161}no`
};


var $734bda6365304ddb$exports = {};
$734bda6365304ddb$exports = {
    "info": `Inform\xe1ci\xf3`,
    "negative": `Hiba`,
    "positive": `Siker`
};


var $c985376db8169cb9$exports = {};
$c985376db8169cb9$exports = {
    "info": `Informazioni`,
    "negative": `Errore`,
    "positive": `Operazione riuscita`
};


var $0a814f0515b1f941$exports = {};
$0a814f0515b1f941$exports = {
    "info": `\u{60C5}\u{5831}`,
    "negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "positive": `\u{6210}\u{529F}`
};


var $87900002a59b18f5$exports = {};
$87900002a59b18f5$exports = {
    "info": `\u{C815}\u{BCF4}`,
    "negative": `\u{C624}\u{B958}`,
    "positive": `\u{C131}\u{ACF5}`
};


var $b083aee709113368$exports = {};
$b083aee709113368$exports = {
    "info": `Informacija`,
    "negative": `Klaida`,
    "positive": `S\u{117}kmingai`
};


var $641d21187f9a9953$exports = {};
$641d21187f9a9953$exports = {
    "info": `Inform\u{101}cija`,
    "negative": `K\u{13C}\u{16B}da`,
    "positive": `Izdev\u{101}s`
};


var $920b9baf5fdd305b$exports = {};
$920b9baf5fdd305b$exports = {
    "info": `Info`,
    "negative": `Feil`,
    "positive": `Vellykket`
};


var $ac88c25d97133768$exports = {};
$ac88c25d97133768$exports = {
    "info": `Info`,
    "negative": `Fout`,
    "positive": `Geslaagd`
};


var $dea3c2ca37b0afea$exports = {};
$dea3c2ca37b0afea$exports = {
    "info": `Informacje`,
    "negative": `B\u{142}\u{105}d`,
    "positive": `Powodzenie`
};


var $36b701dae6c5c88a$exports = {};
$36b701dae6c5c88a$exports = {
    "info": `Informa\xe7\xf5es`,
    "negative": `Erro`,
    "positive": `Sucesso`
};


var $959bf461c37c3856$exports = {};
$959bf461c37c3856$exports = {
    "info": `Informa\xe7\xe3o`,
    "negative": `Erro`,
    "positive": `Sucesso`
};


var $584332ecb6a69cb1$exports = {};
$584332ecb6a69cb1$exports = {
    "info": `Informa\u{21B}ii`,
    "negative": `Eroare`,
    "positive": `Succes`
};


var $b3a312739e8cca16$exports = {};
$b3a312739e8cca16$exports = {
    "info": `\u{418}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44F}`,
    "negative": `\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E}`
};


var $531de2843c7d5aa0$exports = {};
$531de2843c7d5aa0$exports = {
    "info": `Inform\xe1cie`,
    "negative": `Chyba`,
    "positive": `\xdaspech`
};


var $52846db7e4bedb0e$exports = {};
$52846db7e4bedb0e$exports = {
    "info": `Informacije`,
    "negative": `Napaka`,
    "positive": `Uspe\u{161}no`
};


var $20c8bedbc8241336$exports = {};
$20c8bedbc8241336$exports = {
    "info": `Informacije`,
    "negative": `Gre\u{161}ka`,
    "positive": `Uspe\u{161}no`
};


var $7a9bac9c7f5066c3$exports = {};
$7a9bac9c7f5066c3$exports = {
    "info": `Info`,
    "negative": `Fel`,
    "positive": `Lyckades`
};


var $ef512fc21e0fdf2f$exports = {};
$ef512fc21e0fdf2f$exports = {
    "info": `Bilgiler`,
    "negative": `Hata`,
    "positive": `Ba\u{15F}ar\u{131}l\u{131}`
};


var $6764c871b5447c7a$exports = {};
$6764c871b5447c7a$exports = {
    "info": `\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}`,
    "negative": `\u{41F}\u{43E}\u{43C}\u{438}\u{43B}\u{43A}\u{430}`,
    "positive": `\u{423}\u{441}\u{43F}\u{456}\u{448}\u{43D}\u{43E}`
};


var $b1634d37b87f243f$exports = {};
$b1634d37b87f243f$exports = {
    "info": `\u{4FE1}\u{606F}`,
    "negative": `\u{9519}\u{8BEF}`,
    "positive": `\u{6210}\u{529F}`
};


var $19cbd4230357935e$exports = {};
$19cbd4230357935e$exports = {
    "info": `\u{8CC7}\u{8A0A}`,
    "negative": `\u{932F}\u{8AA4}`,
    "positive": `\u{6210}\u{529F}`
};


$41e47081d30453d1$exports = {
    "ar-AE": $4ef3586572b5c0bd$exports,
    "bg-BG": $9294a3bc0be7c803$exports,
    "cs-CZ": $2301cc9fa70c79b7$exports,
    "da-DK": $db68d63440e07cc2$exports,
    "de-DE": $59f85255004b972f$exports,
    "el-GR": $897a62d7e05e3ae7$exports,
    "en-US": $cd5f6f9dc2665e8f$exports,
    "es-ES": $91da3b58720e2afa$exports,
    "et-EE": $d881203a181403bc$exports,
    "fi-FI": $b39cb8320f170f5d$exports,
    "fr-FR": $3dcec82c37bb9c69$exports,
    "he-IL": $70451b8bc8958a93$exports,
    "hr-HR": $8192b2e4907779a9$exports,
    "hu-HU": $734bda6365304ddb$exports,
    "it-IT": $c985376db8169cb9$exports,
    "ja-JP": $0a814f0515b1f941$exports,
    "ko-KR": $87900002a59b18f5$exports,
    "lt-LT": $b083aee709113368$exports,
    "lv-LV": $641d21187f9a9953$exports,
    "nb-NO": $920b9baf5fdd305b$exports,
    "nl-NL": $ac88c25d97133768$exports,
    "pl-PL": $dea3c2ca37b0afea$exports,
    "pt-BR": $36b701dae6c5c88a$exports,
    "pt-PT": $959bf461c37c3856$exports,
    "ro-RO": $584332ecb6a69cb1$exports,
    "ru-RU": $b3a312739e8cca16$exports,
    "sk-SK": $531de2843c7d5aa0$exports,
    "sl-SI": $52846db7e4bedb0e$exports,
    "sr-SP": $20c8bedbc8241336$exports,
    "sv-SE": $7a9bac9c7f5066c3$exports,
    "tr-TR": $ef512fc21e0fdf2f$exports,
    "uk-UA": $6764c871b5447c7a$exports,
    "zh-CN": $b1634d37b87f243f$exports,
    "zh-TW": $19cbd4230357935e$exports
};



var $e05a169dc2f4f928$exports = {};

$parcel$export($e05a169dc2f4f928$exports, "spectrum-Button", () => $e05a169dc2f4f928$export$1db4cca5b4ade39a, (v) => $e05a169dc2f4f928$export$1db4cca5b4ade39a = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-ClearButton", () => $e05a169dc2f4f928$export$b752ce409e5660c, (v) => $e05a169dc2f4f928$export$b752ce409e5660c = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast", () => $e05a169dc2f4f928$export$c8747d73d7954b9c, (v) => $e05a169dc2f4f928$export$c8747d73d7954b9c = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast--info", () => $e05a169dc2f4f928$export$fcf916881d7253a9, (v) => $e05a169dc2f4f928$export$fcf916881d7253a9 = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast--negative", () => $e05a169dc2f4f928$export$bd5a0b226e8b302, (v) => $e05a169dc2f4f928$export$bd5a0b226e8b302 = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast--positive", () => $e05a169dc2f4f928$export$5c8e63d2763f4a55, (v) => $e05a169dc2f4f928$export$5c8e63d2763f4a55 = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast-body", () => $e05a169dc2f4f928$export$36e75d1f579741b3, (v) => $e05a169dc2f4f928$export$36e75d1f579741b3 = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast-buttons", () => $e05a169dc2f4f928$export$19218cf016f919e5, (v) => $e05a169dc2f4f928$export$19218cf016f919e5 = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast-content", () => $e05a169dc2f4f928$export$454f092ca47c3462, (v) => $e05a169dc2f4f928$export$454f092ca47c3462 = v);
$parcel$export($e05a169dc2f4f928$exports, "spectrum-Toast-typeIcon", () => $e05a169dc2f4f928$export$8e9e50fe392680b2, (v) => $e05a169dc2f4f928$export$8e9e50fe392680b2 = v);
var $e05a169dc2f4f928$export$1db4cca5b4ade39a;
var $e05a169dc2f4f928$export$b752ce409e5660c;
var $e05a169dc2f4f928$export$c8747d73d7954b9c;
var $e05a169dc2f4f928$export$fcf916881d7253a9;
var $e05a169dc2f4f928$export$bd5a0b226e8b302;
var $e05a169dc2f4f928$export$5c8e63d2763f4a55;
var $e05a169dc2f4f928$export$36e75d1f579741b3;
var $e05a169dc2f4f928$export$19218cf016f919e5;
var $e05a169dc2f4f928$export$454f092ca47c3462;
var $e05a169dc2f4f928$export$8e9e50fe392680b2;
$e05a169dc2f4f928$export$1db4cca5b4ade39a = `O7O3BG_spectrum-Button`;
$e05a169dc2f4f928$export$b752ce409e5660c = `O7O3BG_spectrum-ClearButton`;
$e05a169dc2f4f928$export$c8747d73d7954b9c = `O7O3BG_spectrum-Toast`;
$e05a169dc2f4f928$export$fcf916881d7253a9 = `O7O3BG_spectrum-Toast--info`;
$e05a169dc2f4f928$export$bd5a0b226e8b302 = `O7O3BG_spectrum-Toast--negative`;
$e05a169dc2f4f928$export$5c8e63d2763f4a55 = `O7O3BG_spectrum-Toast--positive`;
$e05a169dc2f4f928$export$36e75d1f579741b3 = `O7O3BG_spectrum-Toast-body`;
$e05a169dc2f4f928$export$19218cf016f919e5 = `O7O3BG_spectrum-Toast-buttons`;
$e05a169dc2f4f928$export$454f092ca47c3462 = `O7O3BG_spectrum-Toast-content`;
$e05a169dc2f4f928$export$8e9e50fe392680b2 = `O7O3BG_spectrum-Toast-typeIcon`;



var $f3b51ac952d4aeac$exports = {};

$parcel$export($f3b51ac952d4aeac$exports, "fade-out", () => $f3b51ac952d4aeac$export$f562fd61c53bdcd9, (v) => $f3b51ac952d4aeac$export$f562fd61c53bdcd9 = v);
$parcel$export($f3b51ac952d4aeac$exports, "focus-ring", () => $f3b51ac952d4aeac$export$f39a09f249340e2a, (v) => $f3b51ac952d4aeac$export$f39a09f249340e2a = v);
$parcel$export($f3b51ac952d4aeac$exports, "react-spectrum-ToastContainer", () => $f3b51ac952d4aeac$export$bed15bd1aa62542d, (v) => $f3b51ac952d4aeac$export$bed15bd1aa62542d = v);
$parcel$export($f3b51ac952d4aeac$exports, "slide-in", () => $f3b51ac952d4aeac$export$1c220dee9e4dbe34, (v) => $f3b51ac952d4aeac$export$1c220dee9e4dbe34 = v);
$parcel$export($f3b51ac952d4aeac$exports, "spectrum-FocusRing-ring", () => $f3b51ac952d4aeac$export$4109102f950813a6, (v) => $f3b51ac952d4aeac$export$4109102f950813a6 = v);
$parcel$export($f3b51ac952d4aeac$exports, "spectrum-FocusRing", () => $f3b51ac952d4aeac$export$24c7f46a6e3605dd, (v) => $f3b51ac952d4aeac$export$24c7f46a6e3605dd = v);
$parcel$export($f3b51ac952d4aeac$exports, "spectrum-FocusRing--quiet", () => $f3b51ac952d4aeac$export$2927016961429360, (v) => $f3b51ac952d4aeac$export$2927016961429360 = v);
$parcel$export($f3b51ac952d4aeac$exports, "spectrum-Toast", () => $f3b51ac952d4aeac$export$c8747d73d7954b9c, (v) => $f3b51ac952d4aeac$export$c8747d73d7954b9c = v);
var $f3b51ac952d4aeac$export$f562fd61c53bdcd9;
var $f3b51ac952d4aeac$export$f39a09f249340e2a;
var $f3b51ac952d4aeac$export$bed15bd1aa62542d;
var $f3b51ac952d4aeac$export$1c220dee9e4dbe34;
var $f3b51ac952d4aeac$export$4109102f950813a6;
var $f3b51ac952d4aeac$export$24c7f46a6e3605dd;
var $f3b51ac952d4aeac$export$2927016961429360;
var $f3b51ac952d4aeac$export$c8747d73d7954b9c;
$f3b51ac952d4aeac$export$f562fd61c53bdcd9 = `xynrca_fade-out`;
$f3b51ac952d4aeac$export$f562fd61c53bdcd9;
$f3b51ac952d4aeac$export$f39a09f249340e2a = `xynrca_focus-ring`;
$f3b51ac952d4aeac$export$bed15bd1aa62542d = `xynrca_react-spectrum-ToastContainer`;
$f3b51ac952d4aeac$export$1c220dee9e4dbe34 = `xynrca_slide-in`;
$f3b51ac952d4aeac$export$1c220dee9e4dbe34;
$f3b51ac952d4aeac$export$4109102f950813a6 = `xynrca_spectrum-FocusRing-ring`;
$f3b51ac952d4aeac$export$24c7f46a6e3605dd = `xynrca_spectrum-FocusRing ${$f3b51ac952d4aeac$export$4109102f950813a6}`;
$f3b51ac952d4aeac$export$2927016961429360 = `xynrca_spectrum-FocusRing--quiet`;
$f3b51ac952d4aeac$export$c8747d73d7954b9c = `xynrca_spectrum-Toast ${$f3b51ac952d4aeac$export$24c7f46a6e3605dd}`;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







const $e46feef4e4c28a4b$export$9194c0aa0cd7a9ff = /*#__PURE__*/ (0, $jn1ib$createContext)(false);
function $e46feef4e4c28a4b$export$fb98e3a2a4cd92d7(props) {
    let { children: children, state: state } = props;
    let ref = (0, $jn1ib$useRef)();
    let { regionProps: regionProps } = (0, $jn1ib$useToastRegion)(props, state, ref);
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $jn1ib$useFocusRing)();
    let contents = /*#__PURE__*/ (0, $jn1ib$react).createElement((0, $jn1ib$Provider), {
        UNSAFE_style: {
            background: "transparent"
        }
    }, /*#__PURE__*/ (0, $jn1ib$react).createElement($e46feef4e4c28a4b$export$9194c0aa0cd7a9ff.Provider, {
        value: isFocusVisible
    }, /*#__PURE__*/ (0, $jn1ib$react).createElement("div", {
        ...(0, $jn1ib$mergeProps)(regionProps, focusProps),
        ref: ref,
        "data-position": "bottom",
        "data-placement": "center",
        className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($f3b51ac952d4aeac$exports))), "react-spectrum-ToastContainer")
    }, children)));
    return /*#__PURE__*/ (0, $jn1ib$reactdom).createPortal(contents, document.body);
}




const $7e7a2952509f3a56$export$fde44257752a9f60 = {
    info: (0, $jn1ib$spectrumiconsuiInfoMedium),
    negative: (0, $jn1ib$spectrumiconsuiAlertMedium),
    positive: (0, $jn1ib$spectrumiconsuiSuccessMedium)
};
function $7e7a2952509f3a56$var$Toast(props, ref) {
    var _state_visibleToasts_;
    let { toast: { key: key, animation: animation, content: { children: children, variant: variant, actionLabel: actionLabel, onAction: onAction, shouldCloseOnAction: shouldCloseOnAction } }, state: state, ...otherProps } = props;
    let domRef = (0, $jn1ib$useDOMRef)(ref);
    let { closeButtonProps: closeButtonProps, titleProps: titleProps, toastProps: toastProps } = (0, $jn1ib$useToast)(props, state, domRef);
    let { styleProps: styleProps } = (0, $jn1ib$useStyleProps)(otherProps);
    let stringFormatter = (0, $jn1ib$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($41e47081d30453d1$exports))), "@react-spectrum/toast");
    let iconLabel = variant && variant !== "neutral" ? stringFormatter.format(variant) : null;
    let Icon = $7e7a2952509f3a56$export$fde44257752a9f60[variant];
    let isFocusVisible = (0, $jn1ib$useContext)((0, $e46feef4e4c28a4b$export$9194c0aa0cd7a9ff));
    const handleAction = ()=>{
        if (onAction) onAction();
        if (shouldCloseOnAction) state.close(key);
    };
    return /*#__PURE__*/ (0, $jn1ib$react).createElement("div", {
        ...styleProps,
        ...toastProps,
        ref: domRef,
        className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($e05a169dc2f4f928$exports))), "spectrum-Toast", {
            ["spectrum-Toast--" + variant]: variant
        }, styleProps.className, (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($f3b51ac952d4aeac$exports))), "spectrum-Toast", {
            "focus-ring": props.toast.key === ((_state_visibleToasts_ = state.visibleToasts[0]) === null || _state_visibleToasts_ === void 0 ? void 0 : _state_visibleToasts_.key) && isFocusVisible
        })),
        style: {
            ...styleProps.style,
            zIndex: props.toast.priority
        },
        "data-animation": animation,
        onAnimationEnd: ()=>{
            if (animation === "exiting") state.remove(key);
        }
    }, Icon && /*#__PURE__*/ (0, $jn1ib$react).createElement(Icon, {
        "aria-label": iconLabel,
        UNSAFE_className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($e05a169dc2f4f928$exports))), "spectrum-Toast-typeIcon")
    }), /*#__PURE__*/ (0, $jn1ib$react).createElement("div", {
        className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($e05a169dc2f4f928$exports))), "spectrum-Toast-body")
    }, /*#__PURE__*/ (0, $jn1ib$react).createElement("div", {
        className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($e05a169dc2f4f928$exports))), "spectrum-Toast-content"),
        ...titleProps
    }, children), actionLabel && /*#__PURE__*/ (0, $jn1ib$react).createElement((0, $jn1ib$Button), {
        onPress: handleAction,
        UNSAFE_className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($e05a169dc2f4f928$exports))), "spectrum-Button"),
        variant: "secondary",
        staticColor: "white"
    }, actionLabel)), /*#__PURE__*/ (0, $jn1ib$react).createElement("div", {
        className: (0, $jn1ib$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($e05a169dc2f4f928$exports))), "spectrum-Toast-buttons")
    }, /*#__PURE__*/ (0, $jn1ib$react).createElement((0, $jn1ib$ClearButton), {
        ...closeButtonProps,
        variant: "overBackground"
    }, /*#__PURE__*/ (0, $jn1ib$react).createElement((0, $jn1ib$spectrumiconsuiCrossMedium), null))));
}
let $7e7a2952509f3a56$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $jn1ib$react).forwardRef($7e7a2952509f3a56$var$Toast);





// There is a single global toast queue instance for the whole app, initialized lazily.
let $02c59b34bd70955a$var$globalToastQueue = null;
function $02c59b34bd70955a$var$getGlobalToastQueue() {
    if (!$02c59b34bd70955a$var$globalToastQueue) $02c59b34bd70955a$var$globalToastQueue = new (0, $jn1ib$ToastQueue)({
        maxVisibleToasts: 1,
        hasExitAnimation: true
    });
    return $02c59b34bd70955a$var$globalToastQueue;
}
function $02c59b34bd70955a$export$320311f0e4ecb3ae() {
    $02c59b34bd70955a$var$globalToastQueue = null;
}
let $02c59b34bd70955a$var$toastProviders = new Set();
let $02c59b34bd70955a$var$subscriptions = new Set();
function $02c59b34bd70955a$var$subscribe(fn) {
    $02c59b34bd70955a$var$subscriptions.add(fn);
    return ()=>$02c59b34bd70955a$var$subscriptions.delete(fn);
}
function $02c59b34bd70955a$var$triggerSubscriptions() {
    for (let fn of $02c59b34bd70955a$var$subscriptions)fn();
}
function $02c59b34bd70955a$var$getActiveToastContainer() {
    return $02c59b34bd70955a$var$toastProviders.values().next().value;
}
function $02c59b34bd70955a$var$useActiveToastContainer() {
    return (0, $jn1ib$useSyncExternalStore)($02c59b34bd70955a$var$subscribe, $02c59b34bd70955a$var$getActiveToastContainer, $02c59b34bd70955a$var$getActiveToastContainer);
}
function $02c59b34bd70955a$export$f2815235e76a62b9(props) {
    // Track all toast provider instances in a set.
    // Only the first one will actually render.
    // We use a ref to do this, since it will have a stable identity
    // over the lifetime of the component.
    let ref = (0, $jn1ib$useRef)();
    // eslint-disable-next-line arrow-body-style
    (0, $jn1ib$useEffect)(()=>{
        $02c59b34bd70955a$var$toastProviders.add(ref);
        $02c59b34bd70955a$var$triggerSubscriptions();
        return ()=>{
            // When this toast provider unmounts, reset all animations so that
            // when the new toast provider renders, it is seamless.
            for (let toast of $02c59b34bd70955a$var$getGlobalToastQueue().visibleToasts)toast.animation = null;
            // Remove this toast provider, and call subscriptions.
            // This will cause all other instances to re-render,
            // and the first one to become the new active toast provider.
            $02c59b34bd70955a$var$toastProviders.delete(ref);
            $02c59b34bd70955a$var$triggerSubscriptions();
        };
    }, []);
    // Only render if this is the active toast provider instance, and there are visible toasts.
    let activeToastContainer = $02c59b34bd70955a$var$useActiveToastContainer();
    let state = (0, $jn1ib$useToastQueue)($02c59b34bd70955a$var$getGlobalToastQueue());
    if (ref === activeToastContainer && state.visibleToasts.length > 0) return /*#__PURE__*/ (0, $jn1ib$react).createElement((0, $e46feef4e4c28a4b$export$fb98e3a2a4cd92d7), {
        state: state,
        ...props
    }, state.visibleToasts.map((toast)=>/*#__PURE__*/ (0, $jn1ib$react).createElement((0, $7e7a2952509f3a56$export$8d8dc7d5f743331b), {
            key: toast.key,
            toast: toast,
            state: state
        })));
    return null;
}
function $02c59b34bd70955a$var$addToast(children, variant, options = {}) {
    // Dispatch a custom event so that toasts can be intercepted and re-targeted, e.g. when inside an iframe.
    if (typeof CustomEvent !== "undefined" && typeof window !== "undefined") {
        let event = new CustomEvent("react-spectrum-toast", {
            cancelable: true,
            bubbles: true,
            detail: {
                children: children,
                variant: variant,
                options: options
            }
        });
        let shouldContinue = window.dispatchEvent(event);
        if (!shouldContinue) return;
    }
    let value = {
        children: children,
        variant: variant,
        actionLabel: options.actionLabel,
        onAction: options.onAction,
        shouldCloseOnAction: options.shouldCloseOnAction
    };
    // Minimum time of 5s from https://spectrum.adobe.com/page/toast/#Auto-dismissible
    // Actionable toasts cannot be auto dismissed. That would fail WCAG SC 2.2.1.
    // It is debatable whether non-actionable toasts would also fail.
    let timeout = options.timeout && !options.onAction ? Math.max(options.timeout, 5000) : null;
    let queue = $02c59b34bd70955a$var$getGlobalToastQueue();
    let key = queue.add(value, {
        priority: $02c59b34bd70955a$var$getPriority(variant, options),
        timeout: timeout,
        onClose: options.onClose
    });
    return ()=>queue.close(key);
}
const $02c59b34bd70955a$export$f1f8569633bbbec4 = {
    /** Queues a neutral toast. */ neutral (children, options = {}) {
        return $02c59b34bd70955a$var$addToast(children, "neutral", options);
    },
    /** Queues a positive toast. */ positive (children, options = {}) {
        return $02c59b34bd70955a$var$addToast(children, "positive", options);
    },
    /** Queues a negative toast. */ negative (children, options = {}) {
        return $02c59b34bd70955a$var$addToast(children, "negative", options);
    },
    /** Queues an informational toast. */ info (children, options = {}) {
        return $02c59b34bd70955a$var$addToast(children, "info", options);
    }
};
// https://spectrum.adobe.com/page/toast/#Priority-queue
// TODO: if a lower priority toast comes in, no way to know until you dismiss the higher priority one.
const $02c59b34bd70955a$var$VARIANT_PRIORITY = {
    negative: 10,
    positive: 3,
    info: 2,
    neutral: 1
};
function $02c59b34bd70955a$var$getPriority(variant, options) {
    let priority = $02c59b34bd70955a$var$VARIANT_PRIORITY[variant] || 1;
    if (options.onAction) priority += 4;
    return priority;
}




export {$02c59b34bd70955a$export$f2815235e76a62b9 as ToastContainer, $02c59b34bd70955a$export$f1f8569633bbbec4 as ToastQueue};
//# sourceMappingURL=module.js.map
